<template>
  <h1>Hello from protected route!</h1>
</template>

<script>
// eslint-disable-next-line
import { Auth } from "aws-amplify";

export default {
  name: "protected",
  beforeCreate() {
    Auth.currentAuthenticatedUser().then(user => {
      this.user = user;
    });
  }
};
</script>
